var _g, _polygon, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaivIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "6 6 208 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#111311",
    strokeWidth: 28,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20 78 V 46 L 46 20 H 78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 142 20 H 174 L 200 46 V 78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 200 142 V 174 L 174 200 H 142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 78 200 H 46 L 20 174 V 142"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "52,110 110,52 168,110",
    fill: "#5FD884"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "168,110 110,168 52,110",
    fill: "#137F37"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "110,74.04 145.96,110 110,145.96 74.04,110",
    fill: "#22B04B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaivIcon);
export default __webpack_public_path__ + "static/media/paiv-icon.722b34362a1b1d60d2b0d7a78708cea6.svg";
export { ForwardRef as ReactComponent };